import React from 'react';
import {useWindowSize} from "../../../../domain/common";
import PresetDetailsLg from "./preset-details-lg";
import PresetDetailsMobile from "./preset-details-mobile";
import {MAX_TABLET_WIDTH} from "../../common/constants";



const PresetDetails = () => {
    
    const size = useWindowSize();

    return (
        <div className="w-full">
            {size.width !== undefined && size.width > MAX_TABLET_WIDTH ?
                <PresetDetailsLg /> : <PresetDetailsMobile />
            }
        </div>

    )
};

export default PresetDetails;